export class Action{
    
    id : string = null;
    sn : string = null;
    name : string = null;
    category : string = null;
    desc : string = null;

    
    getId(){
        return this.id;
    }
    
    setId(id : string){
        this.id = id;
    }

    getSn(){
        return this.sn;
    }
    
    setSn(sn : string){
        this.sn = sn;
    }
    
    getName(){
        return this.name;
    }
    
    setName(name : string){
        this.name = name;
    }

    
    getCategory(){
        return this.category;
    }
    
    setCategory(cat : string){
        this.category = cat;
    }

    getDsec(){
        return this.desc;
    }
    
    setDsec(desc : string){
        this.desc = desc;
    }

    reset(){
        this.id = null;
        this.sn = null;
        this.name = null;
        this.category = null;
        this.desc = null;
    }

}
